(() => {
  'use strict';
  if (document.body?.dataset.designMode === 'true') return;

  const formatNumber = value => new Intl.NumberFormat(document.documentElement.lang || 'de-DE').format(Number(value) || 0);

  document.querySelectorAll('[data-ebay-trust][data-live-feed]').forEach(async section => {
    const url = section.dataset.liveFeed?.trim();
    const root = section.querySelector('[data-review-summary]');
    if (!url || !root) return;

    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'default' });
      if (!response.ok) return;
      const payload = await response.json();
      const summary = payload?.review_summary;
      if (!summary || typeof summary !== 'object') return;

      const text = root.querySelector('[data-review-summary-text]');
      const count = root.querySelector('[data-review-summary-count]');
      const themes = root.querySelector('[data-review-summary-themes]');
      const method = root.querySelector('[data-review-summary-method]');

      if (text) text.textContent = String(summary.text || '');
      if (count) count.textContent = formatNumber(summary.review_count);
      if (method) {
        method.textContent = summary.ai_generated
          ? 'KI-basierte Zusammenfassung · auf Basis der angezeigten Bewertungsquelle'
          : 'Datengestützte Themenauswertung · keine generative KI';
      }

      if (themes) {
        themes.replaceChildren();
        const rows = Array.isArray(summary.themes) ? summary.themes.slice(0, 4) : [];
        rows.forEach(theme => {
          if (!theme?.label) return;
          const badge = document.createElement('span');
          badge.className = 'nv-review-theme';
          badge.append(document.createTextNode(`${theme.label} `));
          const share = document.createElement('b');
          share.textContent = `${Number(theme.share_percent) || 0}%`;
          badge.append(share);
          badge.title = `${Number(theme.mentions) || 0} von ${Number(summary.review_count) || 0} ausgewerteten Bewertungen erwähnen dieses Thema.`;
          themes.append(badge);
        });
      }

      root.hidden = false;
    } catch (_) {
      // Existing reputation metrics and review cards remain the safe fallback.
    }
  });
})();
